import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { FooterSocialLinks, SocialSectionDataProps } from './FooterSocialLinks';
import { FooterMobileStores, FooterMobileStoresBaseProps } from './FooterMobileStores';
import { generateSeparatorSections } from '../footer.utils';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';

interface AdditionalFooterSectionsProps {
    socialSection: SocialSectionDataProps | null;
    appsSection: FooterMobileStoresBaseProps | null;
    separatorColor: string;
    separatorHeight: number;
}

const getSeparatorStyle = (borderTopColor: string, separatorHeight: number) => {
  return StyleSheet.create({
    style: {
      height: `${separatorHeight}px`,
      width: '100%',
      backgroundColor: borderTopColor,
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'block',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'block',
      },
    },
  });
};

const getWrapperStyle = (numberOfSections: number) => {
  return StyleSheet.create({
    style: {
      display: 'grid',
      justifyItems: 'center',
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: `repeat(${numberOfSections}, 1fr)`,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridTemplateColumns: '1fr',
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
      },
    },
  });
};

const getSocialSection = (socialSection: SocialSectionDataProps | null) => {
  return socialSection ? <FooterSocialLinks key="social-links" {...socialSection as SocialSectionDataProps} /> : null;
};

const getAppsSection = (appsSection: FooterMobileStoresBaseProps | null) => {
  return appsSection ? <FooterMobileStores key="mobile-links" {...appsSection as FooterMobileStoresBaseProps} /> : null;
};

export const AdditionalFooterSections: React.FunctionComponent<AdditionalFooterSectionsProps> = props => {
  const { socialSection, appsSection, separatorColor, separatorHeight } = props;
  const additionalFooterSections = [
    getSocialSection(socialSection),
    getAppsSection(appsSection),
  ].filter(section => section !== null);

  return additionalFooterSections.length === 0 ? null
    : (
      <div className={css(getWrapperStyle(additionalFooterSections.length).style)}>
        {additionalFooterSections.reduce(generateSeparatorSections(getSeparatorStyle(separatorColor, separatorHeight).style), [])}
      </div>
    );
};
